/** True for real pointer/keyboard activation, false for programmatic `.click()`. */
export function isTrustedUserGesture(event: { nativeEvent?: Event; isTrusted?: boolean }): boolean {
  return event.nativeEvent?.isTrusted === true || event.isTrusted === true;
}
